module.exports = __webpack_public_path__ + "static/img/bbb.c81613a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bbb.jpg
// module id = 3lUC
// module chunks = 8